import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/commentList'
        },
        {
            path: '/',
            component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: {
                title: '自述文件'
            },
            children: [{
                    path: '/commentList',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/comment/commentList.vue'),
                    meta: {
                        title: '评论管理'
                    }
                },
                {
                    path: '/replyList',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/comment/replyList.vue'),
                    meta: {
                        title: '回复管理'
                    }
                },
                {
                    path: '/classificationManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/label/classificationManage.vue'),
                    meta: {
                        title: '类别管理'
                    }
                },
                {
                    path: '/labelManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/label/labelManage.vue'),
                    meta: {
                        title: '标签管理'
                    }
                },
                {
                    path: '/zkCategories',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/categories/zk_categories.vue'),
                    meta: {
                        title: '基础分类管理'
                    }
                },
                {
                    path: '/ywCategories',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/categories/yw_categories.vue'),
                    meta: {
                        title: '域外分类管理'
                    }
                },
                {
                    path: '/wqCategories',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/categories/wq_categories.vue'),
                    meta: {
                        title: '孤本分类管理'
                    }
                },
                {
                    path: '/dynastiesManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/book/dynastiesManage.vue'),
                    meta: {
                        title: '朝代管理'
                    }
                },
                {
                    path: '/zkBooks',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/book/zkBooks.vue'),
                    meta: {
                        title: '基础古籍管理'
                    }
                },
                {
                    path: '/ywBooks',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/book/ywBooks.vue'),
                    meta: {
                        title: '域外古籍管理'
                    }
                },
                {
                    path: '/wqBooks',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/book/wqBooks.vue'),
                    meta: {
                        title: '孤本古籍管理'
                    }
                },
                {
                    path: '/bookListManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/book/bookListManage.vue'),
                    meta: {
                        title: '书单管理'
                    }
                },
                {
                    path: '/yianManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/yianManage.vue'),
                    meta: {
                        title: '医案管理'
                    }
                },
                {
                    path: '/bencaoManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/bencaoManage.vue'),
                    meta: {
                        title: '本草管理'
                    }
                },
                {
                    path: '/fangjiManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/fangjiManage.vue'),
                    meta: {
                        title: '方剂管理'
                    }
                },
                {
                    path: '/jingxueManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/jingxueManage.vue'),
                    meta: {
                        title: '经穴管理'
                    }
                },
                {
                    path: '/mingyiManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/mingyiManage.vue'),
                    meta: {
                        title: '名医管理'
                    }
                },
                {
                    path: '/zhenyanManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/zhenyanManage.vue'),
                    meta: {
                        title: '珍言管理'
                    }
                },
                {
                    path: '/zhenyanDayManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/knowledgeBase/zhenyanDayManage.vue'),
                    meta: {
                        title: '珍言推送列表'
                    }
                },
                {
                    path: '/QAMedicine',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/chineseMedicine/qaManage.vue'),
                    meta: {
                        title: '问答管理'
                    }
                },
                {
                    path: '/publicNoteManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/chineseMedicine/publicNoteManage.vue'),
                    meta: {
                        title: '公开笔记管理'
                    }
                },
                {
                    path: '/institutionManage',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/institution/institutionManage.vue'),
                    meta: {
                        title: '机构管理'
                    }
                },
                {
                    path: '/404',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: {
                        title: '404'
                    }
                },
                {
                    path: '/403',
                    component: () => import( /* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: {
                        title: '403'
                    }
                }
            ]
        },
        {
            path: '/login',
            component: () => import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}